import React, { useState,useEffect,useContext } from "react"
import './App.css';
import { AppContext } from "./context/AppContext";
import Select from 'react-select';
import {isMobile} from 'react-device-detect';
import {Outlet,Link } from "react-router-dom";


function App() {
  	
	const [menuOpen,setMenuOpen] = useState(false);
	const {loadUserData,translate,changeLanguage,language,customStyle} = useContext(AppContext);
	
	const toggleMenu = () => {
		setMenuOpen(!menuOpen);
	}
	useEffect(() => {
        loadUserData();
		setMenuOpen(false);
    }, [])
	
	const returnLanguage = () => {
		return [{"value": "en", label: <img src="img/gb.png" alt="english"/>},{"value": "fr", label: <img src="img/fr.png" alt="french"/>}]
	}
	return (
		<div className="App p-2 h-[100vmin]">
			<div className="header mb-2">
				<div className="flex flex-col md:flex-row items-center justify-start w-full">
					<div className='md:w-[40%] w-full flex flex-row items-center justify-between md:justify-start'>
						<div><img src="img/logo.png" alt="logo" className="w-[50px] mr-2"/></div>
						<div className='customTitle tex-bold text-3xl uppercase  bg-clip-text text-transparent bg-gradient-to-r from-[#e97ae9] to-[#fee6d7]'>Dislyte Helper</div>
						<div className='md:hidden'><button onClick={() => toggleMenu()}><img src="img/menu-32.png" width={'32px'} alt="menu"/></button></div>
					</div>
					{!isMobile || menuOpen ? 
					<div className='md:top-0 md:right-0 md:justify-between flex md:flex-row flex-col gap-1 md:items-center w-full'>
						<div>
							<div className='w-full flex flex-col md:flex-row md:gap-5 md:pl-10 items-center'>
								<div className='hover:bg-[#354457] shadow-lg w-full md:w-auto mb-1 md:mb-0 py-2 px-4 border-[#646464] md:border-0 rounded border'>
									<Link onClick={() => setMenuOpen(false)} className="hover:underline" to="/">{translate("Team builder")}</Link>
								</div>
								<div className='hover:bg-[#354457] w-full md:w-auto py-2 px-4 border-[#646464] md:border-0 rounded border'>
									<Link onClick={() => setMenuOpen(false)} className="hover:underline" to="collection">{translate("Collection")}</Link>
								</div>
								<div className='hover:bg-[#354457] w-full md:w-auto py-2 px-4 border-[#646464] md:border-0 rounded border'>
									<Link onClick={() => setMenuOpen(false)} className="hover:underline" to="tier-list">{translate("Tier list")}</Link>
								</div>
								<div className='hover:bg-[#354457] w-full md:w-auto py-2 px-4 border-[#646464] md:border-0 rounded border'>
									<Link onClick={() => setMenuOpen(false)} className="hover:underline" to="esper-list">{translate("Esper list")}</Link>
								</div>
								<div className='hover:bg-[#354457] shadow-lg w-full md:w-auto mb-1 md:mb-0 py-2 px-4 border-[#646464] md:border-0 rounded border'>
									<Link onClick={() => setMenuOpen(false)} className="hover:underline" to="/help">{translate("Help")}</Link>
								</div>
							</div>
						</div>
						<div className='flex md:flex-row flex-col gap-1 items-center'>
							<div className='h-[39px] w-full md:w-auto bg-pink-600 hover:bg-pink-700 text-white py-2 px-4 border-[#646464] rounded border'>
								<a rel="noreferrer" style={{width: '100%'}} className="h-full " href="http://paypal.me/TheConcepteur" target="_blank">💗<span className='md:hidden inline'>{translate("Donate")}</span></a>
							</div>
							<div className='h-[39px] w-full md:w-auto'>
								<Select classNamePrefix='filter w-full' isSearchable={false} defaultValue={returnLanguage().find((e) => e.value === language)} styles={customStyle}  menuPortalTarget={document.body} options={returnLanguage()} onChange={(e) => changeLanguage(e.value)} value={returnLanguage().find((e) => e.value === language)}/>
							</div>
						</div>
            		</div>
					:''}
				</div>
			</div>
			<Outlet />
			
			<div className="footer bg-[#212932] -m-2 p-1 mt-2 bottom-0">
				<div className='flex flex-row justify-between p-2 text-xs'>
					<div>This site is fan-made and not affiliated with Farlight Games or Lilith Games in any way.</div>
					<div>Updated with the 3.1.1.165638 version of the game</div>
					<div>Made with 💗 by TheConcepteur</div>
				</div>
			</div>
		</div>
  	);
}
export default App;
